import { Link } from "react-router-dom";
import { categories } from "@/mocks/kuaibao";

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 font-heading font-bold text-lg">
                5
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading font-bold text-lg text-background-50">
                  51.cg
                </span>
                <span className="font-label text-[11px] tracking-widest text-background-300">
                  今日吃瓜单
                </span>
              </span>
            </div>
            <p className="font-label text-sm text-background-300 leading-relaxed max-w-xs">
              一站集齐今日瓜单与快报总览，用榜单排序与一句话速览，帮你一分钟刷完全部热点，省时省力不迷路。
            </p>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-background-50 mb-4 text-base">
              快捷导航
            </h3>
            <ul className="space-y-2.5 font-label text-sm">
              {[
                { label: "首页", to: "/" },
                { label: "吃瓜快报", to: "/kuaibao" },
                { label: "今日瓜单榜", to: "/kuaibao?sort=heat" },
                { label: "关于我们", to: "/about" },
                { label: "订阅快报", to: "/#subscribe" },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-background-300 hover:text-background-50 transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-background-50 mb-4 text-base">
              内容分类
            </h3>
            <ul className="grid grid-cols-2 gap-2.5 font-label text-sm">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/kuaibao?cat=${cat.slug}`}
                    className="text-background-300 hover:text-background-50 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-background-50 mb-4 text-base">
              联系与反馈
            </h3>
            <ul className="space-y-3 font-label text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base leading-none text-background-200"></i>
                投稿与合作：hello@51cg.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-base leading-none text-background-200"></i>
                每日早 / 中 / 晚三次汇总更新
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-error-warning-line text-base leading-none text-background-200 mt-0.5"></i>
                发现内容有误？欢迎来信，我们会尽快核对修订。
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-label text-xs text-background-400">
            © 2026 51.cg 今日吃瓜单 · 内容仅供浏览参考，请理性看待网络话题
          </p>
          <div className="flex items-center gap-4 font-label text-xs text-background-400">
            <Link to="/about" className="hover:text-background-50 transition-colors">
              内容原则
            </Link>
            <Link to="/kuaibao" className="hover:text-background-50 transition-colors">
              全部快报
            </Link>
            <Link to="/about" className="hover:text-background-50 transition-colors">
              联系反馈
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}